import { FormEvent, useState } from 'react';
import { Card } from 'shared/components/ui/Card';
import { Input } from 'shared/components/ui/Input';
import { Button } from 'shared/components/ui/Button';
import {
  MANUAL_RESERVATION_COURTS,
  MANUAL_RESERVATION_PAYMENT_METHODS,
  MANUAL_RESERVATION_SPORTS,
} from 'modules/arena/reservations/content';
import { ManualReservationInput } from 'modules/arena/reservations/useArenaReservations';

interface NewReservationFormProps {
  onCreate: (input: ManualReservationInput) => void;
  onCancel: () => void;
}

export function NewReservationForm({ onCreate, onCancel }: NewReservationFormProps) {
  const [courtName, setCourtName] = useState(MANUAL_RESERVATION_COURTS[0]);
  const [sport, setSport] = useState(MANUAL_RESERVATION_SPORTS[0]);
  const [dateLabel, setDateLabel] = useState('hoje');
  const [timeLabel, setTimeLabel] = useState('');
  const [durationLabel, setDurationLabel] = useState('1h');
  const [responsiblePlayer, setResponsiblePlayer] = useState('');
  const [totalAmount, setTotalAmount] = useState(80);
  const [paymentMethod, setPaymentMethod] = useState(MANUAL_RESERVATION_PAYMENT_METHODS[0]);

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!responsiblePlayer.trim() || !timeLabel.trim()) return;

    onCreate({
      courtName,
      sport,
      dateLabel,
      timeLabel,
      durationLabel,
      responsiblePlayer: responsiblePlayer.trim(),
      totalAmount,
      paymentMethod,
    });
  }

  return (
    <Card>
      <h3 className="font-heading font-semibold text-ink">Nova reserva em nome de cliente</h3>
      <p className="text-sm text-ink-secondary">
        Para clientes que chegam presencialmente ou reservam por telefone.
      </p>

      <form onSubmit={handleSubmit} className="mt-3 grid gap-3 sm:grid-cols-2">
        <label className="flex flex-col gap-1 text-sm text-ink">
          Quadra
          <select
            value={courtName}
            onChange={(event) => setCourtName(event.target.value)}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {MANUAL_RESERVATION_COURTS.map((court) => (
              <option key={court} value={court}>
                {court}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-1 text-sm text-ink">
          Esporte
          <select
            value={sport}
            onChange={(event) => setSport(event.target.value)}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {MANUAL_RESERVATION_SPORTS.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>

        <Input
          label="Cliente responsável"
          name="responsiblePlayer"
          value={responsiblePlayer}
          onChange={(event) => setResponsiblePlayer(event.target.value)}
          placeholder="Nome do cliente"
        />

        <Input
          label="Data"
          name="dateLabel"
          value={dateLabel}
          onChange={(event) => setDateLabel(event.target.value)}
          placeholder="Ex.: hoje, 12 set"
        />

        <Input
          label="Horário"
          name="timeLabel"
          value={timeLabel}
          onChange={(event) => setTimeLabel(event.target.value)}
          placeholder="Ex.: 18:00–19:00"
        />

        <Input
          label="Duração"
          name="durationLabel"
          value={durationLabel}
          onChange={(event) => setDurationLabel(event.target.value)}
        />

        <Input
          label="Valor total (R$)"
          name="totalAmount"
          type="number"
          min={0}
          step="0.01"
          value={totalAmount}
          onChange={(event) => setTotalAmount(Number(event.target.value))}
        />

        <label className="flex flex-col gap-1 text-sm text-ink">
          Forma de pagamento
          <select
            value={paymentMethod}
            onChange={(event) => setPaymentMethod(event.target.value)}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {MANUAL_RESERVATION_PAYMENT_METHODS.map((method) => (
              <option key={method} value={method}>
                {method}
              </option>
            ))}
          </select>
        </label>

        <div className="col-span-full flex gap-2">
          <Button type="button" variant="ghost" className="flex-1" onClick={onCancel}>
            Cancelar
          </Button>
          <Button type="submit" className="flex-1">
            Criar reserva
          </Button>
        </div>
      </form>
    </Card>
  );
}
